import { EditorTranslationKey, useInterfaceLanguage } from '@/shared/i18n';
import { PaywallCard, PaywallCardLayout } from '@/shared/ui/PaywallCard';

import { DATA_TEST_IDS } from '../../lib/constants';
import { OnscreenOffer } from '../../lib/getOnscreenOffer';
import { getOnscreenPaywallCtaKey } from '../../lib/getOnscreenPaywallCtaKey';
import { OnscreenBeforeAfter } from '../OnscreenBeforeAfter';

const BULLET_KEYS = [
  'editor.visualTranslation.paywall.bulletLanguage',
  'editor.visualTranslation.paywall.bulletDubbing',
  'editor.visualTranslation.paywall.bulletDownload',
] satisfies EditorTranslationKey[];

type OnscreenPaywallViewProps = {
  layout: PaywallCardLayout;
  offer: OnscreenOffer;
  // A modal has a close button; the Visual tab's card does not.
  onClose?: () => void;
  onCta: () => void;
};

export const OnscreenPaywallView = ({ layout, offer, onClose, onCta }: OnscreenPaywallViewProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <PaywallCard
      title={t('editor.visualTranslation.paywall.title')}
      badge={t(
        offer === 'addOn'
          ? 'editor.visualTranslation.paywall.badgeAddOn'
          : 'editor.visualTranslation.paywall.badgeBusiness',
      )}
      bullets={BULLET_KEYS.map((key) => ({ id: key, text: t(key) }))}
      closeLabel={t('pricing.modal.closeAria')}
      ctaLabel={t(getOnscreenPaywallCtaKey(offer))}
      description={t('editor.visualTranslation.paywall.description')}
      layout={layout}
      preview={<OnscreenBeforeAfter />}
      strip={t('editor.visualTranslation.paywall.strip')}
      testId={DATA_TEST_IDS.paywall}
      onClose={onClose}
      onCta={onCta}
    />
  );
};
